import React, { CSSProperties } from 'react';
import { Flex, PaginationButton } from '@lifechurch/react-ion';
import { SubscriberPageInfoFieldsFragment } from '@generated/types';
import { useTranslation } from 'next-i18next';

interface PaginationProps {
  pageInfo: SubscriberPageInfoFieldsFragment | undefined;
  totalCount: number;
  currentPage: number;
  currentPageSize: number;
  pageSize: number;
  onNext: () => void;
  onPrev: () => void;
  styles?: CSSProperties;
}

const Pagination: React.FC<PaginationProps> = ({
  onNext,
  onPrev,
  pageInfo,
  totalCount,
  currentPage,
  currentPageSize,
  pageSize,
  styles,
}) => {
  const showingStart = currentPageSize > 0 ? pageSize * (currentPage - 1) + 1 : 0;
  const showingEnd = Math.min(currentPage * pageSize, totalCount, currentPageSize);
  const { t } = useTranslation('common');

  return (
    <Flex data-testid='pagination-wrapper' style={styles}>
      <Flex alignItems='center' color='gray50' fontSize={2} fontWeight={400} px={5}>
        {t('page_count', { start: showingStart, end: showingEnd, total: totalCount })}
      </Flex>
      {pageInfo?.hasPreviousPage && (
        <PaginationButton
          data-testid={`pagination-prev`}
          pill
          onClick={onPrev}
          style={{ height: 'max-content' }}
        >
          {t('previous')}
        </PaginationButton>
      )}
      {pageInfo?.hasNextPage && (
        <PaginationButton data-testid={`pagination-next`} pill onClick={onNext}>
          {t('next')}
        </PaginationButton>
      )}
    </Flex>
  );
};

export default Pagination;
